export default __webpack_public_path__ + "static/media/logo3.43630d7e.png";